export type Ghe = {
  ghe: number; userId: number; ten: string; stack: number; laBot: boolean;
  bo: boolean; trongVan: boolean; laTay: string[];
} | null;

export type Ban = {
  id: string; rid: number; gid: string; ten: string;
  muNho: number; muLon: number; soGhe: number; soLaTay: number;
  van: string | null; vong: number | null; pot: number; laChung: string[]; ghe: Ghe[];
};

export type Lenh = {
  id: number; ban_id: string; che_do: 'ket_qua' | 'bai'; mot_lan: boolean;
  user_id: number | null; ket_qua: 'thang' | 'thua' | null;
  bai: { la_tay: Record<string, string[]>; la_chung: string[] } | null;
  loi: string | null;
};

export function gheNgoi(b: Pick<Ban, 'ghe'>): NonNullable<Ghe>[] {
  return Array.isArray(b.ghe) ? b.ghe.filter((g): g is NonNullable<Ghe> => !!g) : [];
}

export function gheNguoiThat(b: Pick<Ban, 'ghe'>): NonNullable<Ghe>[] {
  return gheNgoi(b).filter((g) => !g.laBot);
}

// Dua ban co nguoi choi that hoac co lenh cho len dau, giu nguyen thu tu tuong doi khi cung muc uu tien.
export function sapXepBanPoker(ban: Ban[], lenh: Pick<Lenh, 'ban_id'>[]): Ban[] {
  const coLenh = new Set(lenh.map((l) => l.ban_id));
  return ban
    .map((b, idx) => ({
      b,
      idx,
      soNguoiThat: gheNguoiThat(b).length,
      soLenh: coLenh.has(b.id) ? 1 : 0,
      dangVan: b.van ? 1 : 0,
      soNgoi: gheNgoi(b).length,
    }))
    .sort((a, c) => {
      const aThat = a.soNguoiThat > 0 ? 1 : 0;
      const cThat = c.soNguoiThat > 0 ? 1 : 0;
      if (aThat !== cThat) return cThat - aThat;
      if (a.soNguoiThat !== c.soNguoiThat) return c.soNguoiThat - a.soNguoiThat;
      if (a.soLenh !== c.soLenh) return c.soLenh - a.soLenh;
      if (a.dangVan !== c.dangVan) return c.dangVan - a.dangVan;
      if (a.soNgoi !== c.soNgoi) return c.soNgoi - a.soNgoi;
      return a.idx - c.idx;
    })
    .map((x) => x.b);
}

// Giu ban admin da chon neu con trong danh sach; khi chua chon thi tu chon ban dau tien co nguoi that hoac lenh cho.
export function chonBanPokerId(banSapXep: Ban[], lenh: Pick<Lenh, 'ban_id'>[], chonHienTai: string | null): string | null {
  if (chonHienTai && banSapXep.some((b) => b.id === chonHienTai)) return chonHienTai;
  const coLenh = new Set(lenh.map((l) => l.ban_id));
  const uuTien = banSapXep.find((b) => gheNguoiThat(b).length > 0 || coLenh.has(b.id));
  return uuTien ? uuTien.id : null;
}

// Khi chua chon ai va ban co dung 1 nguoi choi that thi tu chon nguoi do; neu nguoi da chon roi ban thi tra null.
export function chonNguoiTrongBan(b: Pick<Ban, 'ghe'>, userIdHienTai: number | null): number | null {
  const ngoi = gheNgoi(b);
  if (userIdHienTai != null) {
    return ngoi.some((g) => g.userId === userIdHienTai) ? userIdHienTai : null;
  }
  const that = ngoi.filter((g) => !g.laBot);
  return that.length === 1 && that[0] ? that[0].userId : null;
}
